import { ShoppingCart } from 'lucide-react';
import { useCart } from '../../../context/CartContext';

interface CartButtonProps {
  className?: string;
  iconSize?: number;
}

export const CartButton = ({ className = '', iconSize = 24 }: CartButtonProps) => {
  const { totalItems, toggleCart } = useCart();

  return (
    <button
      onClick={toggleCart}
      className={`relative p-2 rounded-full sm:bg-white/30  hover:bg-white/50 transition ${className}`}
    >
      <ShoppingCart size={iconSize} />
      <span className="absolute -top-2 -right-2 bg-accent text-primary text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
        {totalItems > 9 ? '9+' : totalItems}
      </span>
    </button>
  );
};